export default __webpack_public_path__ + "static/media/pot1.65aaba57.svg";